import { render, staticRenderFns } from "./Curvas.vue?vue&type=template&id=0c7873f8&scoped=true"
import script from "./Curvas.vue?vue&type=script&lang=js"
export * from "./Curvas.vue?vue&type=script&lang=js"
import style0 from "./Curvas.vue?vue&type=style&index=0&id=0c7873f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7873f8",
  null
  
)

export default component.exports